<template>
    <modal
        v-if="mapInitialized && isActive"
        :show="showModal"
        :showContent="showContent"
        :pageTitle="title"
        :acl="acl"
        :url="url"
        @close="closeModal"
        :closeBtn="closeBtn"
        :data-panel="idPanel"
        position="left"
        class="print-visible">
        <template v-slot:content>
            <div class="panel-control d-flex flex-column flex-fill">
                <div class="panel-control-content d-flex flex-column flex-fill">
                    <div class="card embeded flex-grow-1">
                        <div class="card-header">
                            <span class="title"> {{ title }}</span>
                            <hr/>
                        </div>
                        <div class="card-body scroll d-flex">
                            <form
                                class="flex-column flex-fill"
                                :class="[!startedProcess ? 'd-flex' : 'd-none']"
                                autocomplete="off"
                                method="post">
                                <div class="panel d-flex flex-column h-100"
                                    v-show="activePanel==panels[0]"
                                    :ref="panels[0]"
                                    :key="panels[0]"
                                    role="tabpanel"
                                    :aria-labelledby="panels[0]">
                                    <div class="row flex-grow-1">
                                        <div class="col-12 flex-column d-flex">
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <MaterialSelect
                                                            class="city-form-group city-bg"
                                                            id="input-layout"
                                                            name="layout"
                                                            label="name"
                                                            :filterable="false"
                                                            :clearable="false"
                                                            :options="layouts"
                                                            v-model.trim="form.layout"
                                                            :reduce="option => option.name"
                                                            :data-vv-scope="vScope"
                                                            @input="onLayoutChange"
                                                            v-validate="'required'"
                                                            :inputClasses="[{'is-invalid': fnHasError('layout', vScope)}]"
                                                            :error="fnFirstError('layout', vScope)">
                                                            {{ $t(`${idPanel}.form.layout`) }}
                                                        </MaterialSelect>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <MaterialSelect
                                                            class="city-form-group city-bg"
                                                            id="input-scale"
                                                            name="scale"
                                                            label="name"
                                                            :filterable="false"
                                                            :clearable="false"
                                                            :options="previewScales"
                                                            v-model.trim="form.attributes.map.scale"
                                                            :reduce="option => option.scale"
                                                            :data-vv-scope="vScope"
                                                            @input="onScaleChange"
                                                            v-validate="'required'"
                                                            :inputClasses="[{'is-invalid': fnHasError('scale', vScope)}]"
                                                            :error="fnFirstError('scale', vScope)">
                                                            {{ $t(`${idPanel}.form.scale`) }}
                                                        </MaterialSelect>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group">
                                                        <MaterialSelect
                                                            class="city-form-group city-bg"
                                                            id="input-dpi"
                                                            name="dpi"
                                                            label="name"
                                                            :filterable="false"
                                                            :clearable="false"
                                                            :options="dpis"
                                                            v-model.trim="form.attributes.map.dpi"
                                                            :reduce="option => option.value"
                                                            :data-vv-scope="vScope"
                                                            v-validate="'required'"
                                                            :inputClasses="[{'is-invalid': fnHasError('dpi', vScope)}]"
                                                            :error="fnFirstError('dpi', vScope)">
                                                            {{ $t(`${idPanel}.form.dpi`) }}
                                                        </MaterialSelect>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <MaterialInput
                                                        type="text"
                                                        class="city-form-group city-bg"
                                                        id="input-title"
                                                        name="title"
                                                        v-model.trim="form.attributes.title"
                                                        :data-vv-scope="vScope"
                                                        v-validate="'min:3'"
                                                        :inputClasses="[{'is-invalid': fnHasError('title', vScope)}]"
                                                        :error="fnFirstError('title', vScope)">
                                                        {{ $t(`${idPanel}.form.title`) }}
                                                    </MaterialInput>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <div class="form-group city-form-group city-bg">
                                                        <MaterialTextarea
                                                            class="city-form-group city-bg"
                                                            id="input-obs"
                                                            name="obs"
                                                            :rows="6"
                                                            v-model.trim="form.attributes.obs"
                                                            v-validate="'min:10'"
                                                            :data-vv-scope="vScope"
                                                            :inputClasses="[{'is-invalid': fnHasError('obs', vScope)}]"
                                                            :error="fnFirstError('obs', vScope)">
                                                            {{ $t(`${idPanel}.form.obs`) }}
                                                        </MaterialTextarea>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <span>{{ scaleLabel }}</span>
                                                </div>
                                            </div>
                                            <div class="row flex-grow-1">
                                                <div class="col-12 pb-3">
                                                    <div :id="targetMap" class="print-map map-wrapper" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row form-btns">
                                        <div class="text-center col-sm-12">
                                            <button
                                                :disabled="loading || !form.layout"
                                                class="btn btn-main btn-rounded btn-sm btn-block min-w-auto"
                                                type="button"
                                                @click.prevent="process">
                                                {{ buttons['finish'] }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </form>

                            <!-- PROCESS WORKFLOW -->
                            <print-process-workflow
                                v-if="startedProcess"
                                :id="idProcess"
                                :description="printDescription"
                                :url="url.getStatusPrint"
                                :canceled="canceledProcess"
                                :showBtnClose="false"
                                @close="closeModal"/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
    import ButtonControlMixin from '@/components/maps/mixins/ButtonControlMixin';
    import ProcessJobMixin from '@/app/shared/components/workflow/mixins/ProcessJobMixin';
    import PrintProviderMixin from '../shared/print/mixins/PrintProviderMixin';
    import { MAP_ACTIONS } from '@config/constants';
    import { formatUrl } from '@config/utils';
    import { boundingExtent, isEmpty, getCenter, getForViewAndSize, createEmpty, extend } from 'ol/extent';
    import { Feature } from 'ol';
    import VectorLayer from 'ol/layer/Vector';
    import { Vector as VectorSource } from 'ol/source';
    import { fromExtent as PolygonFromExtent} from "ol/geom/Polygon";
    import Translate from "ol/interaction/Translate";
    import Collection from 'ol/Collection';

    let varsOriginal = {
        extentLayer: null,
        interactions: {
            translate: null,
        }
    };

    let vars = Object.assign({}, varsOriginal);

    let INCHES_PER_UNIT = {
        'inches': 1.0,
        'ft': 12.0,
        'mi': 63360.0,
        'm': 39.37,
        'km': 39370,
        'dd': 4374754,
        'yd': 36
    };

    export default {
        components:{
            Modal: () => import(/* webpackChunkName: "modal-data" */ '@/app/shared/components/modals/ModalData'),
            PrintProcessWorkflow: () => import(/* webpackChunkName: "common-process-workflow" */ '@/app/shared/components/workflow/CommonProcessWorkflow'),
        },
        mixins: [
            ButtonControlMixin,
            PrintProviderMixin,
            ProcessJobMixin,
        ],
        props: {
            panelID: {
                type: String,
                default: null,
                require: true,
            },
            closeBtn: {
                type: Boolean,
                default: true
            },
            defaultLayout: {
                type: String,
                default: 'A4 portrait',
            },
            defaultOutputFormat: {
                type: String,
                default: 'pdf',
            },
            //If set to true, the printPage cannot be set to scales that would generate a preview with a completely different extent than the one that would appear on the printed map. Default is false.
            limitScales: {
                type: Boolean,
                default: false
            },
            actionName: {
                type: String,
                default: MAP_ACTIONS.PRINT_VISIBLE,
            },
        },
        data() {
            return {
                idPanel: null,
                className: 'ol-printvisible',
                loading: false,
                showContent: true,
                panels: [
                    'panel-detail',
                ],
                panelSelected: null,
                _updating: false,
                previewFeatures: new Collection(),
                draw: {
                    types: [],
                    features: [],
                },
                //By default, this contains all the scales of the printProvider. If limitScales is set to true, it will only contain print scales that can properly be previewed
                previewScales: [],
                // printProvider: {
                //     mapClientInfo: {},
                //     mapClientParams: {},
                // },
                form: {
                    layout: null,
                    outputFormat: null,
                    attributes: {
                        map: {
                            dpi: 72,
                            center: null,
                            scale: null,
                            rotation: 0,
                        },
                        title: null,
                        obs: null,
                    }
                },
                resolutionScale: null,
                printMap: null,
            }
        },
        beforeMount() {
            this.idPanel = this.panelID;
        },
        created () {
            this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', this.closeModal);
            this.$eventBus.listen(this.moduleCode, 'map.start-street-view-panorama', this.closeModal);
        },
        beforeDestroy() {
            this.reset();
            this.$eventBus.remove(this.moduleCode, 'map.new-feature-initialize', this.closeModal);
            this.$eventBus.remove(this.moduleCode, 'map.start-street-view-panorama', this.closeModal);
        },
        computed: {
            vScope() {
                return `${this.idPanel}-${this.panels[0]}`;
            },
            showModal() {
                return this.isActive && this.isPanelVisible;
            },
            activePanel(){
                return this.panelSelected ? this.panelSelected : this.panels[0];
            },
            configMap() {
                return this.moduleCode ? this.$store.getters.getConfigMap(this.moduleCode) : {};
            },
            defaultStyleMap() {
                return this.moduleCode ? this.$store.getters.getPrintStyleMap(this.moduleCode) : {};
            },
            editingStyleMap() {
                return this.moduleCode ? this.$store.getters.getEditingStyleMap(this.moduleCode) : {};
            },
            buttons() {
                return {
                    'finish':  this.$t(`${this.idPanel}.buttons.finish`),
                    'close': this.$t(`${this.idPanel}.buttons.close`)
                }
            },
            layouts() {
                return this.capabilities && this.capabilities.layouts ? this.capabilities.layouts : [];
            },
            layout() {
                return this.layouts.find(layout => layout.name === this.form.layout);
            },
            formats() {
                return this.capabilities && this.capabilities.formats ? this.capabilities.formats : [];
            },
            defaultDpi() {
                return 72;
            },
            viewProjection(){
                let _map = this.getMap();
                return _map ? _map.getProjection() : null;
            },
            viewUnits(){
                return this.viewProjection?.getUnits();
            },
            viewScale(){
                let _map = this.getMap();
                return _map ? _map.getScaleForResolution(this.viewResolution, this.defaultDpi) : null;
            },
            viewResolution(){
                let _map = this.getMap();
                return _map ? _map.getResolution() : null
            },
            viewCenter(){
                let _map = this.getMap();
                return _map ? _map.getCenter() : null
            },
            viewExtent(){
                let _map = this.getMap();
                return _map ? _map.getExtent() : null;
            },
            viewSize(){
                let _map = this.getMap();
                return _map ? _map.getSize() : null;
            },
            dpis(){
                return this.getLayoutDPIs().map( item => {
                    return {'name': `${item} dpi`, 'value': item};
                });
            },
            dpi() {
                return this.form.attributes.map.dpi;
            },
            resolutions(){
                let _map = this.getMap();
                return _map ? _map.getResolutions() : [];
            },
            scale() {
                return this.form.attributes.map.scale;
            },
            scales(){
                let _map = this.getMap();
                if(_map){
                    let resolutions = this.resolutions;
                    return resolutions
                        .filter((el, index) => index >= _map.getMinZoom())
                        .map(res => Math.round(_map.getScaleForResolution(res, this.defaultDpi)));
                }
                return [];
            },
            scaleLabel() {
                return this.resolutionScale ? this.getLabelScale(this.resolutionScale) : '';
            },
            rotation() {
                return this.form.attributes.map.rotation ?? 0; // || this.printProvider.mapClientParams?.rotation?.default
            },
            printDescription() {
                return `A ${this.title} foi gerada com sucesso.`;
            },
            targetMap() {
                return 'printMap';
            },
            feature() {
                return this.previewFeatures.getLength() ? this.previewFeatures.item(0) : null;
            },
            featureGeometry(){
                return this.feature?.getGeometry();
            },
        },
        methods: {
            initialize: function() {
                if(this.createLayer()){
                    this.addBaseInteractions();
                    this.setPrintProvider();
                    // this.cloneMap();
                    this.$store.dispatch(`setActionMap`, {module: this.moduleCode, action: this.actionName});
                }
                return;
            },
            reset: function(){
                Object.assign(this.$data.draw, this.$options.data().draw);
                Object.assign(this.$data.form, this.$options.data().form);
                // Object.assign(this.$data.printProvider, this.$options.data().printProvider);
                this.resetJob();
                let _map = this.getMap();
                if(_map){
                    let layer = vars.extentLayer;
                    if(layer){
                        this.removeInteractions();
                        // Triggered when a property is changed.
                        if(_map.getOLMap()){
                            _map.getOLMapView().un('propertychange', this.onPropertyChangeView);
                        }
                        layer.getSource().clear();
                        _map.removeLayer(layer);
                        vars.extentLayer = null;
                    }
                }
                if(this.printMap){
                    // _map.getLayers.on("propertychange", (e) => {
                    _map.deleteClonedMap(this.printMap);
                    this.printMap = null;
                }
                this.panelSelected = null;
                vars = Object.assign({}, varsOriginal);
                this.resetValidator();
                this.$store.dispatch(`setActionMap`, {module: this.moduleCode, action: null});
            },
            closeModal: function() {
                this.closePanel(this.idPanel);
            },
            addButtonMap: function(_map){
                let btn = _map.createBtnImg(
                    this.assetsPathTheme('/map/print-visible.svg'),
                    _map.getControlClassName(this.orderClassName),
                    this.title,
                    [
                        {
                            type: 'click',
                            event: (evt) =>
                            {
                                this.openPanel(this.idPanel);
                                evt.stopPropagation();
                            }
                        }
                    ],
                    this.lblBtn
                );
                _map.addControl(this.posBtnMap, btn);
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-initialize', (evt)=>{
                    let el = $(btn.element); if(el) el.hide()
                });
                this.$eventBus.listen(this.moduleCode, 'map.new-feature-finished', (evt)=>{
                    let el = $(btn.element); if(el) el.show()
                });
                return btn;
            },
            async cloneMap() {
                if(this.printMap) {
                    return new Promise((resolve) => {
                        resolve();
                    });
                }else{
                    let _map = this.getMap();
                    return await _map.cloneMap(_map, this.targetMap, _map.getLayers(), _map.getOLMapView())
                        .then((map)=>{
                            this.printMap = map;
                        });
                }
            },
            createLayer: function(){
                let layer = vars.extentLayer;
                if(!layer){
                    let config = this.configMap.layers.draw;
                    let source = new VectorSource({
                        useSpatialIndex: false,
                        wrapX: config.wrapX !== undefined ? config.wrapX : false, //Wrap the world horizontally on the sketch overlay.
                        features: this.previewFeatures,
                    });
                    let feat = new Feature(PolygonFromExtent(boundingExtent([[-1, -1], [1, 1]])));
                    source.addFeature(feat);

                    layer = new VectorLayer({
                        source: source,
                        visible: true,
                        zIndex: config.zindex,
                        style: config.style ? config.style : this.defaultStyleMap,
                    });
                    this.getMap().addLayer(layer);
                    vars.extentLayer = layer;
                }
                return layer;
            },
            addBaseInteractions: function(){
                // Translate
                this.createTranslateInteraction();
            },
            createTranslateInteraction: function(){
                if(!vars.interactions.translate){
                    let translate = vars.interactions.translate = new Translate({
                        features: this.previewFeatures,
                    });
                    translate.on('translateend', evt => {
                        let features = evt.features;
                        let extent = createEmpty();
                        features.forEach(function(feat){ extend(extent, feat.getGeometry().getExtent())});
                        this.setCenter(getCenter(extent))
                    })
                    translate.setActive(true);
                    this.getMap().addInteraction(translate);
                }
            },
            removeInteractions: function(keys='all'){
                for (let key in vars.interactions) {
                    if(keys == 'all' || keys.includes(key)){
                        let interaction = vars.interactions[key];
                        if(interaction){
                            let _map = interaction.getMap();
                            if(_map){
                                _map.removeInteraction(interaction);
                            }
                            vars.interactions[key] = null;
                        }
                    }
                }
            },
            setPrintProvider: function(){
                if(!this.capabilities){
                    this.loadCapabilitiesPrint()
                    .then( (capabilities) => {
                        this.onPrintProviderReady(capabilities);
                    });
                }else{
                    this.onPrintProviderReady(this.capabilities);
                }
            },
            onPrintProviderReady: function(capabilities) {
                // SELECT FIRST LAYOUT IF NOT DEFINED
                if(!this.form.layout && this.layouts.length){
                    this.setLayout((this.layouts.find(layout => layout.name == this.defaultLayout) ?? this.layouts[0]).name);
                }
                // SELECT VIEW SCALE IF NOT DEFINED
                if(!this.scale){
                    this.form.attributes.map.scale = this.viewScale;
                }
                // SELECT FIRST FORMAT IF NOT DEFINED
                if(!this.form.outputFormat && this.formats.length){
                    this.form.outputFormat = this.formats.find(format => format == this.defaultOutputFormat) ?? this.formats[0];
                }

                let _map = this.getMap();
                if(_map){
                    this.fit();
                }
            },
            onPropertyChangeView: function(evt) {
                // console.log('onPropertyChangeView', evt)
            },
            // renderPrintExtent: function(clear=false) {
            //     console.log('renderPrintExtent')
            //     let layer = vars.extentLayer;
            //     if(layer){
            //         let source = layer.getSource();
            //         if(clear){
            //             source.clear();
            //             source.refresh();
            //         }
            //         //return;
            //         let mapClientInfo = this.printProvider.mapClientInfo;
            //         if(isEmptyObject(mapClientInfo)){
            //             return;
            //         }

            //         let mapComponent = this.getMap().getOLMap();
            //         let mapComponentWidth = mapComponent.getSize()[0];
            //         let mapComponentHeight = mapComponent.getSize()[1];
            //         let currentMapRatio = mapComponentWidth / mapComponentHeight;
            //         let scaleFactor = 0.6;
            //         let desiredPrintRatio = mapClientInfo.width / mapClientInfo.height;
            //         let targetWidth;
            //         let targetHeight;
            //         let geomExtent;
            //         let feat;

            //         if (desiredPrintRatio >= currentMapRatio) {
            //             targetWidth = mapComponentWidth * scaleFactor;
            //             targetHeight = targetWidth / desiredPrintRatio;
            //         } else {
            //             targetHeight = mapComponentHeight * scaleFactor;
            //             targetWidth = targetHeight * desiredPrintRatio;
            //         }

            //         geomExtent = mapComponent.getView().calculateExtent([
            //             targetWidth,
            //             targetHeight
            //         ]);
            //         feat = new Feature(PolygonFromExtent(geomExtent));
            //         source.addFeature(feat);
            //         return feat;
            //     }
            // },
            getPrintExtent: function(map) {
                return this.calculateExtent(this.scale);
            },
            getLayoutSize: function() {
                let width, height = 0;
                let layout = this.layout;
                if(layout) {
                    let dsAttribute = layout.attributes.find( attribute => attribute.type === 'DataSourceAttributeValue');
                    if(dsAttribute){
                        let mapAttribute = dsAttribute.clientParams.attributes.find( attribute => attribute.type === 'MapAttributeValues');
                        if(mapAttribute){
                            width = mapAttribute.clientInfo.width;
                            height = mapAttribute.clientInfo.height;
                            // this.printProvider.mapClientInfo = Object.assign({}, mapAttribute.clientInfo);
                            // this.printProvider.mapClientParams = Object.assign({}, mapAttribute.clientParams);
                        }
                    }
                }
                return [width, height];
            },
            getLayoutDPIs: function() {
                let layout = this.layout;
                if(layout) {
                    let dsAttribute = layout.attributes.find( attribute => attribute.type === 'DataSourceAttributeValue');
                    if(dsAttribute){
                        let mapAttribute = dsAttribute.clientParams.attributes.find( attribute => attribute.type === 'MapAttributeValues');
                        if(mapAttribute){
                            return mapAttribute.clientInfo.dpiSuggestions;
                        }
                    }
                }
                return [];
            },
            onLayoutChange(layout) {
                this.setLayout(layout);
            },
            onScaleChange(scale) {
                this.setScale(scale);
            },
            validate: function(scope) {
                if (!scope) {
                    return this.$validator.validate();
                }
                return this.$validator.validateAll(scope);
            },
            process: function() {
                let panel = this.activePanel;
                let vScope = `${this.idPanel}-${panel}`;
                this.validate(vScope)
                .then(valid => {
                    if (valid) {
                        if(this.panels.indexOf(panel) == this.panels.length-1){
                            this.submitProcess();
                        }else{
                            this.panelSelected = this.panels[this.panels.indexOf(panel)+1];
                        }
                    }
                });
            },
            submitProcess: function() {
                try {
                    this.loading = true;

                    this.clearMessages();
                    this.$validator.validateAll()
                    .then(result => {
                        if(!result){
                            this.showError($t(`global.msg.error.form`));
                            return;
                        }

                        let spec = {
                            'spec': this.getSpec(),
                        };
                        let url = this.url.createPrint;
                        if (url) {
                            this.$http.post(formatUrl(url, {applicationCode: this.applicationCode, format: this.form.outputFormat}), spec)
                            .then( res => {
                                let data = res.data.data;
                                if(data && data.jobId){
                                    this.job.id = data.jobId;
                                }else{
                                    this.showError(data);
                                }
                            })
                            .catch( error => {
                                this.showHttpError(error);
                            })
                            .finally(() => this.loading = false)
                        }
                    });
                }
                catch(err) {
                    this.showError(err);
                }
                finally {
                    this.loading = false;
                }
            },
            getSpec: function() {
                let _map = this.getMap();
                if(!_map) return;

                let layer = vars.extentLayer;
                let serializedLayers = this.getSerializedLayers(
                    _map.getOLMap(),
                    function(_layer) {
                        // do not print the extent layer
                        let isExtentLayer = (layer === _layer);
                        return !isExtentLayer;
                    },
                    this
                );
                serializedLayers.reverse();

                // MAP ATTRIBUTES
                let spec = JSON.parse(JSON.stringify(this.form));
                spec.attributes.map.layers = serializedLayers;
                spec.attributes.map.projection = this.viewProjection.getCode();
                return spec;
            },
            getLabelScale: function(val, template = `${this.idPanel}.form.scale_descr`) {
                return this.$tc(template, val, { scale: Math.round(val).toLocaleString() });
            },
            fit: function(options = {}) {
                let extent;
                if(!extent) {
                    extent = this.viewExtent;
                    if(!extent) {
                        return;
                    }
                }
                this._updating = true;
                let center = getCenter(extent);
                let scale = this.scale;
                this.setCenter(center);
                this.setScale(scale, this.viewUnits);

                this._updating = false;
                this.updateFeature(this.featureGeometry, {
                    center: center,
                    scale: scale
                });
            },
            setLayout: function(layout) {
                this.form.layout = layout;
                this.calculateScales();
                // if(this.layout && this.layout.get("rotation") === false) {
                //     this.setRotation(this.rotation);
                // }
                this.resetValidator();
                this.setScale(this.viewScale);
            },
            /**
             * Updates the page geometry to match a given scale. Since this takes the
             * current layout of the printProvider into account, this can be used to
             * update the page geometry feature when the layout has changed.
             */
            setScale: function(scale, units) {
                if(!scale) return;

                let extent = this.calculateExtent(scale, units);
                let geom = isEmpty(extent) ? null : PolygonFromExtent(extent);
                if(!geom) return;

                let rotation = this.rotation;
                if(rotation && rotation != 0) {
                    geom.rotate(-rotation, geom.getCentroid());
                }
                this.updateFeature(geom, {scale: scale});
            },
            /**
             * Sets a new rotation for the page geometry.
             */
            setRotation: function(rotation, force) {
                if(force || this.layout.get("rotation") === true) {
                    let geom = this.feature?.geometry;
                    if(geom) {
                        geom.rotate(this.rotation - rotation, geom.getCentroid());
                        this.updateFeature(geom, {rotation: rotation});
                    }
                }
            },
            /**
             * Moves the page extent to a new center.
             */
            setCenter: function(center) {
                let geom = this.featureGeometry;
                let oldCenter = getCenter(geom.getExtent());
                let centerX = center[0];
                let centerY = center[1];
                let dx = centerX - oldCenter[0];
                let dy = centerY - oldCenter[1];
                geom.translate(dx, dy);
                this.updateFeature(geom, {center: center});
            },
            /**
             * Updates the page feature with a new geometry and notifies listeners
             * of changed page properties.
             */
             updateFeature: function(geometry, mods) {
                let f = this.feature;
                let modified = f.getGeometry() != geometry;
                f.setGeometry(geometry);

                if(!this._updating) {
                    for(let property in mods) {
                        if(mods[property] === this.form.attributes.map[property]) {
                            delete mods[property];
                        } else {
                            this.form.attributes.map[property] = mods[property];
                            modified = true;
                        }
                    }
                }
            },
            /**
             * Calculates the page bounds for a given scale.
             */
            calculateExtent: function(scale, units) {
                let s = scale;
                let f = this.feature;
                let geom = f?.getGeometry();
                let center = geom ? getCenter(geom.getExtent()) : this.viewCenter;
                let size = this.getLayoutSize();

                units = units || this.viewProjection.getUnits() || "dd";
                let unitsRatio = INCHES_PER_UNIT[units];
                const scaleResolution = s / (this.viewProjection.getMetersPerUnit() * unitsRatio * this.defaultDpi);

                return getForViewAndSize(center, scaleResolution, this.rotation, size);
            },
            /**
             * Recalculates all preview scales. This is e.g. needed when the size
             * changes.
             */
            calculateScales: function() {
                this.previewScales = [];
                let scales = this.scales
                .map((scale, index) => {
                    return {
                        'id': index + 1,
                        'scale': scale,
                        'name': this.getLabelScale(scale)
                    }
                });

                scales.unshift({
                    'id': 0,
                    'scale': this.viewScale,
                    'name': this.getLabelScale(this.viewScale, `${this.idPanel}.form.current_scale_descr`)
                });

                this.previewScales = scales;
            },
        },
        watch: {
            showModal: {
                immediate: false,
                handler(value, oldVal) {
                    if(value){
                        this.initialize();
                    }else{
                        this.reset();
                    }
                },
            },
        },
    }
</script>

<style lang="scss">
@import "@styles/_mixins.scss";
.print-map {
    min-height: 250px;

    @include sm {
        min-height: auto;
    }
}
</style>